
<template>
  <!--管理员操作日志-->
  <div>
    <x-tabula
      :dataSource="dataSource"
      rowKey="opt_log_id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :rowSelection="false"
    >
      <template slot="opt_o" slot-scope="{row}">
        <a-button type="link" @click="showAccountInfo(row)">{{row.user_name}}</a-button>
      </template>
    </x-tabula>

    <!--账号详情的弹窗-->
    <a-modal
      title="管理员信息"
      :visible="visible"
      @cancel="visible=false"
      :width="700"
      v-bind="$store.state.modalDetailConfig"
    >
      <a-form>
        <a-form-item
          v-for="(item, index) of accountInfo"
          :key="index"
          :label="item.label"
          v-bind="{labelCol: { span: 4 }, wrapperCol: { span: 9 }}"
        >
          <span class="ant-form-text">{{item.value}}</span>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import mixin from '../../js/mixins';
export default {
  mixins: [mixin.fetchSelect],
  name: 'operationLog',
  data () {
    return {
      visible: false,
      searchList: [
        { props: ['keywords'], placeholder: '账号、手机号', options: [], inputType: 'input' },
        { props: ['role_id'], placeholder: '角色', options: [], inputType: 'select' },
        { props: ['type'], placeholder: '操作类型', options: [], inputType: 'select' },
        { props: ['create_time'], placeholder: ['操作时间', '操作时间'], options: [], inputType: 'datePick' }
      ],
      tableOptList: [],
      columns: [
        { title: 'ID', dataIndex: 'opt_log_id', align: 'left', width: '' },
        { title: '操作时间', dataIndex: 'create_time', align: 'left', width: '' },
        { title: '账号名', dataIndex: 'user_name', align: 'left', width: '', scopedSlots: {customRender: 'action_o'} },
        { title: '操作类型', dataIndex: 'option_type_desc', align: 'left', width: '' },
        { title: '操作内容', dataIndex: 'remark', align: 'left', width: '' },
        { title: '操作IP', dataIndex: 'option_ip', align: 'left', width: '' }
      ],
      dataSource: [],
      searchParams: {
        keywords: '',
        role_id: '',
        type: '',
        create_time: ''
      },
      accountInfo: [
        { label: '账号', key: 'user_name', value: '' },
        { label: '角色', key: 'role_desc', value: '' },
        { label: '手机号', key: 'mobile', value: '' },
        { label: '真实姓名', key: 'true_name', value: '' }
      ],
      listApi: {
        url: '/potion_log',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      }
    };
  },
  mounted () {
    this.getSelect();
  },
  methods: {
    getSelect () {
      this.$get({
        url: '/select_list/admin_manage_list',
        params: {}
      }).then(({data}) => {
        this.searchList[1].options = data.roles_list;
        this.searchList[2].options = data.msg_type;
      });
    },
    /* 查看账号详情 */
    showAccountInfo (row) {
      this.accountInfo.forEach((el) => {
        for (let item in row) {
          if (item === el.key) {
            el.value = row[item];
          }
        }
      });
      this.visible = true;
    },
    resHandle (res) {
      console.log('处理list返回数据: ');
      return res;
    },
    searchHandle (selectData) {
      console.log('处理搜索数据: ', selectData);
      // return selectData;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/managerCenter/operationLog.vue